// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__3X8lI","actions":"GroupTable_actions__1_7mF","deleteModalFooter":"GroupTable_deleteModalFooter__YhdJf"};